import React from "react"
import { ProductVariant } from "../../../../types/product"
import CustomSelect from "../../../../ui/atoms/CustomSelect"
import ColorPreview from "../../../../ui/molecules/ColorPreview"
import classes from "./ProductColorDropdown.module.css"

interface Props {
  variants: ProductVariant[]
  selectedVariant: ProductVariant
  onVariantSelect: (variant: ProductVariant) => void
  fullWidth?: boolean
}

const ProductColorDropdown = ({
  onVariantSelect,
  selectedVariant,
  variants,
  fullWidth,
}: Props) => {
  const hasShade = (variant: ProductVariant) =>
    variant.info.color?.hex || variant.info.color?.asset

  const selectableColors = variants.filter(
    (x) => hasShade(x) || x.info.color?.name
  )

  const handleVariantChange = (newVariantId: string) => {
    onVariantSelect(
      variants.find((x) => x.info.variantId === newVariantId) as ProductVariant
    )
  }

  return (
    <CustomSelect
      zIndex={5}
      classes={{
        select: classes.select,
        panel: classes.selectPanel,
      }}
      fixed={selectableColors.length <= 1}
      values={selectableColors.map((variant) => ({
        id: variant.info.variantId,
        label: (
          <div className="flex items-center">
            {hasShade(variant) && (
              <ColorPreview
                size="14px"
                colorValue={variant.info.color?.hex}
                shadeUrl={variant.info.color?.asset}
                noPadding
              />
            )}
            <div
              className={`colorName pl-2 ${
                hasShade(variant) ? "hidden" : ""
              } sm:block`}
            >
              {variant.info.color?.name}
            </div>
          </div>
        ),
      }))}
      value={selectedVariant.info.variantId}
      onChange={handleVariantChange}
      size="small"
      variant="outlined"
      fullWidth={fullWidth}
    />
  )
}

export default ProductColorDropdown
